import { ComponentPropsWithoutRef } from 'react'

export const SanityIcon = (
    props: ComponentPropsWithoutRef<'svg'> & { size?: number },
) => {
    return (
        <svg
            fill="currentColor"
            width={props.size}
            height={props.size}
            viewBox="0 0 172 138"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <title>Sanity</title>
            <path
                d="M166.467 91.1548L160.09 80.3741L129.251 98.6238L163.508 56.2524L168.687 53.3048L167.407 51.4375L169.756 48.5251L158.951 39.776L153.995 45.9062L54.1503 102.652L91.0726 59.5289L159.832 22.912L153.303 10.6398L115.852 30.5807L134.29 9.04267L123.72 0L82.2178 48.4898L40.9856 70.4389L72.5527 29.9113L92.3292 19.9174L86.058 7.50424L28.4198 36.6522L44.1447 16.453L33.1643 7.91527L0 50.545L0.516727 50.956L6.70567 63.2047L43.487 44.6144L9.97042 87.6434L15.4547 91.9181L18.7195 98.0484L57.4386 77.4381L14.8088 127.243L25.3664 136.274L27.4921 133.796L130.344 75.1598L96.1929 117.402L96.7566 117.86L96.6979 117.884L103.779 129.85L149.192 102.981L131.706 130.391L143.426 137.86L171.271 94.2199L166.467 91.1548Z"
            />
        </svg>
    )
}